import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BatchStatsDisplay} from '../../service/datamanagement/batchStatsDisplay.js';


/* global customElements */
class TaskGrid extends BaseComponent {
	
	static get properties() {
		return {
			user: {type: Boolean},
			widgetmode: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.user = false;
		this.widgetmode = false;
		
		var taskGrid = this;
		setTimeout(function(){
			taskGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var taskGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',			
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (taskGrid.user ? 'display: none;' : ''),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						if (!taskGrid.user) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},	
				{
					tag: 'vaadin-combo-box',
					label: 'Task Status',
					itemid: 'filterStatus',
					'class': 'spacer-toolbar-item',
					name: 'taskStatus',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'keep-open': true,					
					postinit: function (combo) {
						Service.getLookupService().getLookupValues('BatchTaskStatus').then(function (data) {
							combo.items = data;
						});
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
				},	
				{
					tag: 'vaadin-combo-box',
					label: 'Task Type',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					name: 'taskType',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'keep-open': true,						
					postinit: function (combo) {
						Service.getLookupService().getLookupValues('BatchTaskType').then(function (data) {
							combo.items = data;
						});
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
				},											
				{
					tag: 'span',
					itemId: 'mainToolSeparator',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'display',
					'class': 'spacer-toolbar-item',
					style: 'width: 225px;',
					disabled: true,					
					permissions: ['ADMIN_BATCH_MANAGEMENT:READ', 'COMPANY_BATCH_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:lines', ' Display')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								itemId: 'details',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:modal-list"></vaadin-icon> Details',
								listeners: {
									click: function(event) {
										actionShowDetails(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemId: 'units',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:truck"></vaadin-icon> Units',
								listeners: {
									click: function(event) {
										actionShowUnits(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemId: 'work',
								style: (taskGrid.user ? 'display: none;' : ''),
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:cogs"></vaadin-icon> Outstanding Work',
								listeners: {
									click: function(event) {
										actionShowWork(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								itemId: 'errors',							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:flag" style="color: red;"></vaadin-icon> Errors',
								listeners: {
									click: function(event) {
										actionShowErrors(grid.selectedItems[0]);
									}
								}
							}
						]
					}					
				},				
				{
					tag: 'dl-action-button',
					itemid: 'control',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_BATCH_MANAGEMENT:CONTROL', 'COMPANY_BATCH_MANAGEMENT:CONTROL'],
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Control')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								itemId: 'suspend',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:pause"></vaadin-icon> Suspend',
								listeners: {
									click: function(event) {
										actionSuspend(grid.selectedItems[0]);
									}
								}
							},							
							{
								tag: 'vaadin-item',
								itemId: 'resume',							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:play-circle"></vaadin-icon> Resume',
								listeners: {
									click: function(event) {
										actionResume(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								itemId: 'cancel',	
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:close"></vaadin-icon> Cancel',
								listeners: {
									click: function(event) {
										actionCancel(grid.selectedItems[0]);	
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								itemId: 'restart',	
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:rotate-right"></vaadin-icon> Restart',
								listeners: {
									click: function(event) {
										actionRestart(grid.selectedItems[0]);	
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								itemId: 'verifyRunning',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:search"></vaadin-icon> Verify Running',
								listeners: {
									click: function(event) {
										actionVerifyRunning(grid.selectedItems[0]);
									}
								}
							}
						]
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BATCH_MANAGEMENT:DELETE', 'COMPANY_BATCH_MANAGEMENT:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;margin-top: 18px;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function(event) {
							actionDelete(grid.selectedItems);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'clearComplete',
					theme: 'error',
					permissions: ['ADMIN_BATCH_MANAGEMENT:CLEAR_COMPLETED'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;margin-top: 18px;' + (taskGrid.user ? 'display: none;' : ''),
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Clear Completed')
					],
					listeners: {
						click: function(event) {
							actionClearComplete();
						}
					}
				}
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [	
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-width': true,
					'auto-select': true,
					listeners: {						
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},
				{
					tag: 'vaadin-grid-column',
					path: 'companyName',
					header: 'Company Name',
					resizable: true,
					width: '7em'
				},
				{						
					tag: 'vaadin-grid-column',
					path: 'batchTaskTypeDescription',
					header: 'Type',
					resizable: true,
					'text-align': 'center',
					width: '10em',
					renderer: function(root, column, rowData) {
						var typeDescription = rowData.item.batchTaskTypeDescription || '';
						var taskDetail = rowData.item.taskDetail;
						if (taskDetail) {
							root.innerHTML = typeDescription
								+ '<div style="color: var(--lumo-secondary-text-color); font-size: var(--lumo-font-size-s); line-height: 1.2; margin-top: 2px;">'
								+ taskDetail
								+ '</div>';
						} else {
							root.innerHTML = typeDescription;
						}
					}
				},	
				{						
					path: 'fullStatus.description',
					header: 'Status',
					resizable: true,
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {	
						if (rowData.item.status === 'ERROR') {
							root.style.backgroundColor = 'rgb(180, 31, 31)';
							root.style.color = 'white';
						} else if (rowData.item.status === 'WARNING') {
							root.style.backgroundColor = 'rgb(249, 249, 17)';
							root.style.color = 'black';
						} else if (rowData.item.adminTask) {
							root.style.backgroundColor = 'orange';
							root.style.color = 'black';
						} else if (rowData.item.status === 'CANCELED') {
							root.style.backgroundColor = '#848484';
							root.style.color = '';
						} else if (rowData.item.status === 'SUSPENDED') {
							root.style.backgroundColor = '#8d8d73';
							root.style.color = '';
						} else if (rowData.item.status === 'WORKING') {
							root.style.backgroundColor = '#77bf77';
							root.style.color = '';
						} else {
							root.style.backgroundColor = '';
							root.style.color = '';
						}
						root.innerHTML = rowData.item.fullStatus.description;						
					}
				},
				{						
					tag: 'vaadin-grid-column',
					path: 'stats',
					header: 'Stats',
					resizable: true,
					width: '11em',					
					renderer: function(root, column, rowData) {						
						if (rowData.item.batchStats) {
							root.innerHTML = BatchStatsDisplay.formatStatsGridHtml(
								rowData.item.batchTaskType,
								rowData.item.batchStats,
								rowData.item.split
							);
						} else {						
							root.innerHTML = '';						
						}
					}
				},
				{
					tag: 'vaadin-grid-column',
					path: 'progress',
					header: 'Progress',
					resizable: true,
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						if (rowData.item.fullStatus.inProgressState) {
							if (rowData.item.batchStats.percentComplete === -1) {
								root.innerHTML = '<vaadin-progress-bar indeterminate value="0"></vaadin-progress-bar>';
							} else {
								root.innerHTML = rowData.item.batchStats.percentComplete + '%<br><vaadin-progress-bar value="' + (rowData.item.batchStats.percentComplete/100) + '"></vaadin-progress-bar>';
							}
						} else if (rowData.item.fullStatus.finalState) {
							root.innerHTML = '100%<br><vaadin-progress-bar value="1"></vaadin-progress-bar>';
						} else if (rowData.item.fullStatus.stopState) {
							root.innerHTML = '<vaadin-progress-bar indeterminate value="0"></vaadin-progress-bar>';
						} else {
							root.innerHTML = '<vaadin-progress-bar value="0"></vaadin-progress-bar>';
						}
					}
				},
				{
					tag: 'vaadin-grid-column',
					path: 'runtime',
					header: 'Run Time',
					resizable: true,
					width: '9em',
					renderer: function(root, column, rowData) {
						var startDate = TimeUtil.parseDate(rowData.item.startDts);
						var completeDate = TimeUtil.parseDate(rowData.item.completedDts);
						var status = rowData.item.status;
						
						var runtime = '-:-:-';
						if (startDate && completeDate) {
							var millis = completeDate.getTime() - startDate.getTime();
							runtime = TimeUtil.milliToDisplay(millis);
						} else if (startDate && (status === 'SUSPENDED' || status === 'SUSPENDING')) {
							var endDate = TimeUtil.parseDate(rowData.item.updateDts) || new Date();
							runtime = TimeUtil.milliToDisplay(endDate.getTime() - startDate.getTime());
						} else if (startDate) {
							var millis = (new Date()).getTime() - startDate.getTime();
							runtime = TimeUtil.milliToDisplay(millis);
						}						
						root.innerHTML = runtime;						
					}
				},
				{
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					direction: 'desc',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
		
		var gridSelectionChange = function() {
			//delay for the check box
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {	

					ElementUtil.query(toolbar, 'delete').disabled = false; 

					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'control').disabled = false; 				
						ElementUtil.query(toolbar, 'display').disabled = false;

						//complex cases of the control
						var record = grid.selectedItems[0];
						ElementUtil.query(toolbar, 'suspend').disabled = true;
						ElementUtil.query(toolbar, 'resume').disabled = true;
						ElementUtil.query(toolbar, 'cancel').disabled = true;
						ElementUtil.query(toolbar, 'restart').disabled = true;

						if (record.fullStatus.waitState) {
							ElementUtil.query(toolbar, 'cancel').disabled = false;
						} else if (record.fullStatus.inProgressState) {
							ElementUtil.query(toolbar, 'suspend').disabled = false;
							ElementUtil.query(toolbar, 'cancel').disabled = false;
						} else if (record.fullStatus.stopState) {
							ElementUtil.query(toolbar, 'resume').disabled = false;
						} else if (record.fullStatus.finalState) {
							if (record.restartable) {	
								ElementUtil.query(toolbar, 'restart').disabled = false;
							}
						}

					} else {
						ElementUtil.query(toolbar, 'control').disabled = true; 				
						ElementUtil.query(toolbar, 'display').disabled = true; 					
					}								
				} else {						
					ElementUtil.query(toolbar, 'display').disabled = true;
					ElementUtil.query(toolbar, 'control').disabled = true;
					ElementUtil.query(toolbar, 'delete').disabled = true; 
				}			
			});
		};
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
									
					var sortColumn = 'updateDts';
					var sortDirection = 'DESC';
					
					var loadData = function(companyId) {
						taskGrid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : sortColumn,
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : sortDirection,
							companyId: companyId,
							taskStatus: ElementUtil.query(toolbar, 'filterStatus').value,
							taskType: ElementUtil.query(toolbar, 'filterType').value
						};

						var successHandler = function(records) {
							loadMask.remove();
							
							//clear selection; setting the active item to null (re-add in item in multi-select)																			
							grid.items = records.data;
							grid.selectedItems = [];										
							gridSelectionChange();
						

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};

						DataManagementService.getBatchTaskService().getTasks(taskGrid.currentFilter)
								.then(function(records){							
							successHandler(records);
						});	
					};					
					
					if (taskGrid.user) {
						Service.getCompanyService().getCurrentCompany().then(function(companyFull){
							loadData(companyFull.company.companyId);
						});
					} else {
						loadData(ElementUtil.query(toolbar, 'filtercompany').value);
					}					
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, taskGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				DataManagementService.getBatchTaskService().exportTasks(exportFilter);
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		taskGrid.append(flexLayout);		
				
		
		if (taskGrid.widgetmode) {
			setTimeout(function(){
				ElementUtil.query(toolbar, 'filterStatus').classList.add('hide');
				ElementUtil.query(toolbar, 'filterType').classList.add('hide');
				ElementUtil.query(toolbar, 'display').classList.add('hide');
				ElementUtil.query(toolbar, 'control').classList.add('hide');
				ElementUtil.query(toolbar, 'delete').classList.add('hide');
				ElementUtil.query(toolbar, 'mainToolSeparator').classList.add('hide');
			});
		}
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(taskGrid, toolbar, ['filterStatus','filterType','filtercompany'], actionRefresh);
				
		var actionSuspend = function(task) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Suspend',
				message: 'Are you sure you want to <b>Suspend</b> the selected task?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Suspending Task...');

							DataManagementService.getBatchTaskService().suspend(task.taskId)
							.then(function(result){
								loadMask.remove();
								if (result.success) {
									window.DL.MessageUtil.showToast('Success', 'Submitted request to Suspend Task', {									
										theme: 'success'
									});
									actionRefresh();
								} else {
									window.DL.MessageUtil.showToastError(result.data, 'Failed to Suspend');
								}
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
		};

		var actionVerifyRunning = function(task) {
			var loadMask = grid.showLoading('Locating running thread...');
			DataManagementService.getBatchTaskService().locateRunningThreads(task.taskId).then(function(result) {
				loadMask.remove();
				if (!result) {
					window.DL.MessageUtil.showToastError('Unable to locate running threads for this task.');
					return;
				}
				var matchHtml = '';
				(result.matches || []).forEach(function(match) {
					var thread = match.thread || {};
					matchHtml += '<div style="margin-bottom: 12px; border-bottom: 1px solid #ddd; padding-bottom: 8px;">'
						+ '<div><b>Node:</b> ' + (match.nodeId || '') + '</div>'
						+ '<div><b>Thread:</b> ' + (thread.name || '') + '</div>'
						+ '<div><b>Status:</b> ' + (thread.status || '') + '</div>'
						+ '<div style="margin-top: 6px; max-height: 220px; overflow: auto; font-family: monospace; font-size: 11px;">'
						+ (thread.details || '')
						+ '</div></div>';
				});
				if (!matchHtml) {
					matchHtml = '<div><i>No matching threads found.</i></div>';
				}
				var guidance = result.guidance
					? '<div style="margin-bottom: 12px; padding: 8px; background: #fff8e1;">' + result.guidance + '</div>'
					: '';
				var dialog = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Verify Running — ' + task.taskId,
					icon: 'vaadin:search',
					width: .7,
					height: .7,
					listeners: {
						ready: function() {
							dialog.show();
						}
					},
					children: [
						{
							tag: 'div',
							style: 'padding: 12px; overflow: auto; height: 100%;',
							innerHTML: guidance + matchHtml
						}
					]
				});
			});
		};
		
		var actionResume = function(task) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Resume',
				message: 'Are you sure you want to <b>Resuming</b> the selected task?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Resuming Task...');

							DataManagementService.getBatchTaskService().resume(task.taskId)
							.then(function(result){
								loadMask.remove();
								if (result.success) {
									window.DL.MessageUtil.showToast('Success', 'Submitted request to Resume Task', {									
										theme: 'success'
									});
									actionRefresh();
								} else {
									window.DL.MessageUtil.showToastError(result.data, 'Failed to Resume');
								}
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
		};
		
		var actionRestart = function(task) {
			
			if (task.batchTaskType === 'CALCULATION') {
				
				var calcStageWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Restart Calculation',
					icon: 'vaadin:rotate-right',
					width: 400,
					height: 250,
					listeners: {
						ready: function () {
							calcStageWin.show();

							var formPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-combo-box',																											
												name: 'calcStage',															
												label: 'Calculation Stage To Start From',
												'item-value-path': 'code',
												'item-label-path': 'description',
												postinit: function (combo) {
													Service.getLookupService().getLookupValues('CalculationStage').then(function(data) {																	
														combo.items = data;																	
													});
												},															
												placeHolder: 'First Stage'
											},											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:rotate-right', ' Restart')
														],
														listeners: {
															click: function () {
															
																var data = formPanel.getData();
																var loadMask = grid.showLoading('Restarting Task...');
																DataManagementService.getBatchTaskService().restart(task.taskId, data.calcStage)
																.then(function(result){
																	loadMask.remove();
																	if (result.success) {
																		window.DL.MessageUtil.showToast('Success', 'Submitted request to Restart Task', {									
																			theme: 'success'
																		});									
																		actionRefresh();
																	} else {
																		window.DL.MessageUtil.showToastError(result.data, 'Failed to Restart');
																	}								
																});
															
															
																actionRefresh();
																calcStageWin.close();
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function () {
																//cancel
																calcStageWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
							});

							calcStageWin.addToContentElement(formPanel);
						}
					}
				});				
				
				
			} else {		
				window.DL.MessageUtil.showConfirm({
					title: 'Confirm Restart',
					message: 'Are you sure you want to <b>Restart</b> the selected task?',
					buttons: [
						{
							text: 'Yes',
							handler: function() {
								var loadMask = grid.showLoading('Restarting Task...');

								DataManagementService.getBatchTaskService().restart(task.taskId)
								.then(function(result){
									loadMask.remove();
									if (result.success) {
										window.DL.MessageUtil.showToast('Success', 'Submitted request to Restart Task', {									
											theme: 'success'
										});									
										actionRefresh();
									} else {
										window.DL.MessageUtil.showToastError(result.data, 'Failed to Restart');
									}								
								});						
							}
						},
						{
							text: 'No'
						}
					]
				});	
			}
		};
		
		var actionCancel = function(task) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Cancel',
				message: 'Are you sure you want to <b>Cancel</b> the selected task?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Canceling Task...');

							DataManagementService.getBatchTaskService().cancel(task.taskId)
							.then(function(result){
								loadMask.remove();
								if (result.success) {
									window.DL.MessageUtil.showToast('Success', 'Submitted request to Cancel Task', {									
										theme: 'success'
									});
									actionRefresh();
								} else {
									window.DL.MessageUtil.showToastError(result.data, 'Failed to Cancel');
								}	
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
		};
		
		var actionDelete = function(tasks) {
			
			//all selected tasks must not be in a working state
			var proceed = true;
			var requestModel = {
				ids: []
			};			
			tasks.forEach(function(item){
				if (item.fullStatus.inProgressState) {
					proceed = false;
				}
				requestModel.ids.push(item.taskId);
			});
			
			if (proceed) {			
				window.DL.MessageUtil.showConfirm({
					title: 'Confirm Delete',
					message: 'Are you sure you want to delete the selected task(s)?',
					buttons: [
						{
							text: 'Yes',
							handler: function() {
								var loadMask = grid.showLoading('Removing Task(s)...');

								DataManagementService.getBatchTaskService().deleteBatchTask(requestModel)
								.then(function(){
									loadMask.remove();
									window.DL.MessageUtil.showToast('Success', 'Removed Task(s)', {									
										theme: 'success'
									});
									actionRefresh();
								});						
							}
						},
						{
							text: 'No'
						}
					]
				});
			} else {
				window.DL.MessageUtil.showOkMessage('Unable to delete a selected task is still in progress.');
			}
		};

		var actionClearComplete = function() {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Clear Completed',
				message: 'Are you sure you want to permanently delete all completed (non-error) batch tasks? This cannot be undone.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Clearing completed tasks...');

							DataManagementService.getBatchTaskService().clearCompleteTasks()
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Cleared completed tasks', {
									theme: 'success'
								});
								actionRefresh();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
		};
		
		var actionShowDetails = function(task) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Details',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailWin.show();
						
						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});
						
						var data = [
							{
								key: 'Task Details',
								value: '-',
								section: true
							},			
							{
								key: 'Company Id',
								value: task.companyId
							},
							{
								key: 'Company Name',
								value: task.companyName
							},
							{
								key: 'Status',
								value: task.fullStatus.description
							},
							{
								key: 'Type',
								value: task.batchTaskTypeDescription
							},
							{
								key: 'Task Detail',
								value: task.taskDetail ? task.taskDetail : 'N/A'
							},
							{
								key: 'Description',
								value: task.description
							},
							{
								key: 'Restart Count',
								value: task.restartCount
							},
							{
								key: 'Admin Task',
								value: task.adminTask
							},
							{
								key: 'Merged',
								value: task.merged
							},
							{
								key: 'Create Node',
								value: task.createNode
							},							
							{
								key: 'Data Start Date',
								value: task.dataStartDate ? TimeUtil.formatDateStandard(task.dataStartDate) : "N/A"
							},
							{
								key: 'Data End Date',
								value: task.dataEndDate ? TimeUtil.formatDateStandard(task.dataEndDate) : "N/A"  
							},
							{
								key: 'Start Date',
								value: task.startDts ? TimeUtil.formatDateStandard(task.startDts) : "Not Started"  
							},
							{
								key: 'Complete Date',
								value: task.completedDts ? TimeUtil.formatDateStandard(task.completedDts) : ""  
							},
							{
								key: 'Create User',
								value: task.createUser
							},
							{
								key: 'Create Date',
								value: TimeUtil.formatDateStandard(task.createDts)
							},
							{
								key: 'Update User',
								value: task.updateUser
							},
							{
								key: 'Last Update Date',
								value: TimeUtil.formatDateStandard(task.updateDts)
							},										
							{
								key: 'Batch Stats',
								value: '-',
								section: true
							},
							{
								key: 'Detail Status',
								value: task.batchStats.detailStatus ? task.batchStats.detailStatus : "N/A"
							},
							{
								key: 'Stages (completed/total)',
								value: (task.batchStats.completedStages || 0) + ' / ' + (task.batchStats.totalStages || 0)
							},
							{
								key: 'Total Error',
								value: task.batchStats.totalErrors
							},
							{
								key: 'Total Warnings',
								value: task.batchStats.totalWarnings
							}						
						];

						var taskStatRows = BatchStatsDisplay.buildTaskStatDetailRows(task.batchTaskType, task.batchStats);
						taskStatRows.forEach(function(statRow) {
							data.push(statRow);
						});						
						
						if (!ElementUtil.isEmpty(task.properties)) {
							data.push({
								key: 'Properties',
								value: '-',
								section: true
							});
							
							for (var key in task.properties) {
								data.push({
									key: key,
									value: task.properties[key]
								});
							}
						}
						
						detailTable.updateDetails(data);
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								detailTable
							]
						});	
						
						detailWin.addToContentElement(layout);
					}
				}
			});		
		};

		var actionShowUnits = function(task) {
			var unitWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Units',
				icon: 'vaadin:truck',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						unitWin.show();
						
						var unitGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [									
								{						
									path: 'referenceTypeDescription',
									header: 'Reference Type',									
									width: '7em'
								},
								{						
									path: 'referenceNo',
									header: 'Reference No',									
									width: '7em'
								},
								{						
									path: 'processStartDts',
									header: 'Start Date',									
									width: '7em',
									renderer: function(root, column, rowData) {	
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.processStartDts);
									}
								},
								{						
									path: 'processEndDts',
									header: 'End Date',									
									width: '7em',
									renderer: function(root, column, rowData) {	
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.processEndDts);
									}
								},
								{						
									path: 'unitId',
									header: 'Unit Id',									
									width: '7em'
								}
							],
							listeners: {
							}
						});	

						var unitPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 250,
							postinit: function(element) {
								element.grid = grid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = unitGrid.showLoading();

									unitGrid.currentFilter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'referenceNo',
										sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
									};

									var successHandler = function(records) {
										loadMask.remove();
										unitGrid.activeItem = null;											
										unitGrid.items = records.data;

										unitPagingToolbar.totalRecords = records.totalNumber;
										unitPagingToolbar.updatePager();						
									};

									DataManagementService.getBatchTaskService().getTaskUnits(task.taskId, unitGrid.currentFilter)
											.then(function(records){							
										successHandler(records);
									});										
								};
							},
							listeners: {
								ready: function() {					
									unitPagingToolbar.loadCurrentPage();					
								}
							}

						});						
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								unitGrid,
								unitPagingToolbar
							]
						});	
						
						
						
						unitWin.addToContentElement(layout);
					}
				}
			});
			
		};
		
		var actionShowWork = function(task) {
			var unitWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Outstanding Work',
				icon: 'vaadin:cogs',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						unitWin.show();
					
						var workGrid = ElementUtil.create({
							tag: 'dl-batchwork-grid',
							slot: 'primary',
							taskId: task.taskId
						});
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								workGrid
							]
						});
						
						unitWin.addToContentElement(layout);
					}
				}
			});
			
		};

		var actionShowErrors = function(task) {
			var errorWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Errors',
				icon: 'vaadin:flag',
				iconStyle: 'color: red;',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						errorWin.show();
						
						var errorGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column'								
							},			
							children: [
								{
									tag: 'vaadin-grid-column',
									'flex-grow': '0',
									width: '50px',										
									renderer: function(root, column, rowData) {
										var expander = ElementUtil.create({
											tag: 'span',
											trustedInnerHTML: true,
											innerHTML: '<b>+</b>',
											properties: {
												expanded: false
											},
											listeners: {
												click: function() {
													if (expander.expanded) {
														expander.innerHTML = '<b>+</b>';
														expander.expanded = false;
														errorGrid.closeItemDetails(root.item);
													} else {
														expander.innerHTML = '<b>-</b>';
														expander.expanded = true;
														errorGrid.openItemDetails(root.item);
													}
												}
											}
										});
										//this must be set for expand to open
										root.item = rowData.item;
										if (!root.firstElementChild) {
											root.append(expander);
										}
									}
								},								
								{						
									path: 'taskErrorTypeDescription',
									header: 'Type',
									resizable: true,
									width: '7em'
								},
								{						
									path: 'errorMessage',
									header: 'Message',									
									resizable: true,
									width: '7em'
								},
								{						
									path: 'referenceId',
									header: 'Reference Id',									
									resizable: true,									
									hidden: true,
									width: '7em'
								},
								{						
									path: 'trace',
									header: 'Trace',									
									resizable: true,
									hidden: true,
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									errorGrid.selectedItems = item ? [item] : [];										
								}
							}
						});	
						
						errorGrid.rowDetailsRenderer = function(root, grid, rowData) {
							if (!root.firstElementChild) {
								root.innerHTML = '<div style="border: 1px solid"><div style="padding: 5px;">' + 
										(rowData.item.trace ? rowData.item.trace : (rowData.item.errorMessage ? rowData.item.errorMessage : '(No Additional Details)')) + 
										'</div></div>';
							}
						};						

						var errorPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 250,
							postinit: function(element) {
								element.grid = grid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = errorGrid.showLoading();

									errorGrid.currentFilter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'referenceNo',
										sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
									};

									var successHandler = function(records) {
										loadMask.remove();
										errorGrid.activeItem = null;						
										errorGrid.items = records.data;

										errorPagingToolbar.totalRecords = records.totalNumber;
										errorPagingToolbar.updatePager();						
									};

									DataManagementService.getBatchTaskService().getTaskErrors(task.taskId, errorGrid.currentFilter)
											.then(function(records){							
										successHandler(records);
									});										
								};
							},
							listeners: {
								ready: function() {					
									errorPagingToolbar.loadCurrentPage();					
								}
							}

						});						
						
						var exportToolbar = ElementUtil.create({
							tag: 'dl-export-toolbar',
							itemid: 'task-errors',
							children: [								
							],
							listeners: {
								ready: function () {
									exportToolbar.updateGrid(errorGrid);
								},
								'click-detail': function () {
									DataManagementService.getBatchTaskService().exportTaskErrors(task.taskId, errorGrid.currentFilter);								
								}
							}
						});	
						
						var footerContainer = ElementUtil.create({
							tag: 'div',
							slot: 'footer',
							children: [
								exportToolbar,
								{
									tag: 'div',
									style: 'border-top: 1px solid lightgrey;'
								},
								errorPagingToolbar
							]
						});						
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								errorGrid,
								footerContainer
							]
						});	
						
						errorWin.addToContentElement(layout);
					}
				}
			});
		};	
	
	}
	
}
customElements.define('dl-task-grid', TaskGrid);

